<ng-container *ngIf="advertisement">
    <div class="relative ad-container" [ngClass]="{'ad-container-md': imageWidth<=960, 'ad-container-sm': imageWidth<=540}" #adContainer>
        <img [src]="advertisement.image" alt="advertisement image" [ngStyle]="{'height': imageHeight+'px', 'width': imageWidth+'px'}" 
            class="ad-image fit-cover" [ngClass]="{'ad-image-md': imageWidth<=960, 'ad-image-sm': imageWidth<=540}">
        <div class="absolute width-100  image-overlay" [ngClass]="{'image-overlay-md': imageWidth<=960}">
            <div fxLayout="column" fxLayoutGap="24px" class="detail-container absolute">
                <ng-container *ngTemplateOutlet="detailView">
                </ng-container>
            </div>
        </div>
        <div fxLayout="column" fxLayoutGap="24px" class="detail-container mobile-view-detail"
        [ngClass]="{'detail-container-md': imageWidth<=960, 'mobile-view-detail-md': imageWidth>960}">
            <ng-container *ngTemplateOutlet="detailView">
            </ng-container>
        </div>
    </div>
</ng-container>


<ng-template #detailView>
    <div fxLayout="column" fxLayoutGap="8px">
        <p class="margin-0 font-bolder font-md">{{ advertisement.title }}</p>
        <div class="margin-0 font-sm"[innerHtml]="advertisement.content | safeContent"></div>
    </div>
    <a [href]="advertisement.url" target="_blank" class="button-section no-decor"
        [ngClass]="{'button-section-md': imageWidth<=960, 'button-section-sm': imageWidth<=540}">
        <p class="margin-0 font-md">{{advertisement.link_title ? advertisement.link_title : 'Learn More' }}</p>
    </a>
</ng-template>